import RepositoryFinder from "@/wc/registry/lib/service/repository/finder.js";
import RepositoryLister from "@/wc/registry/lib/service/repository/lister.js";

const finder = new RepositoryFinder();
const lister = new RepositoryLister();

lister.setFinder(finder);

export default lister;
